import { masterRoleKey, systemRoles } from '@/constants/access';
import upperFirst from 'lodash/upperFirst';

export function isAgentIqEmailAddress(email) {
  const AGENTIQ_EMAIL_SUFFIX = '@agentiq.com';
  if (!email) {
    return false;
  }

  return email.toLowerCase().endsWith(AGENTIQ_EMAIL_SUFFIX);
}

export function getAgentRoleNames(agentRoles) {
  if (!agentRoles) {
    return [];
  }
  return agentRoles
    .filter(role => role !== masterRoleKey) // Exclude master role
    .map(role => ({
      name: role,
      label: upperFirst(role),
      hidden: false, // default to false, can be set to true for specific roles if needed
    }))
    // sort system roles first, then alphabetically
    .sort((a, b) => {
      if (systemRoles.includes(a.name) && !systemRoles.includes(b.name)) {
        return -1; // a is a system role, b is not
      }
      if (!systemRoles.includes(a.name) && systemRoles.includes(b.name)) {
        return 1; // b is a system role, a is not
      }

      // both are either system roles or not, sort alphabetically
      if (a.name < b.name) return -1;
      if (a.name > b.name) return 1;

      return 0; // both are either system roles or not
    });
}